"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const InputField_1 = __importDefault(require("../../../components/input/InputField"));
const ModalExplain_1 = __importDefault(require("../../../components/modal/ModalExplain"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const ForgotPassword = (props) => {
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [email, setEmail] = (0, react_1.useState)("");
    const [visibleEmail, setVisibleEmail] = (0, react_1.useState)(false);
    const [errEmail, setErrorEmail] = (0, react_1.useState)("");
    const validate = () => {
        react_native_1.Keyboard.dismiss();
        let check = false;
        if (!email || email.trim() == "") {
            setErrorEmail("メールアドレスは必ず指定してください。");
            check = true;
        }
        else if (!constants_1.REGEX_EMAIL.test(email)) {
            setErrorEmail("メールアドレスには、有効なメールアドレスを指定してください");
            check = true;
        }
        if (!check) {
            props.navigation.navigate("CONFIRM_FORGOT", { email: email });
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                    paddingRight: (0, scale_1.scale)(20),
                    fontSize: 14,
                }, title: "パスワードを忘れた方", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: "#292A33" }), onLeftPress: () => {
                    (0, rootNavigation_1.goBack)();
                } }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u767A\u884C")),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            fontWeight: "300",
                            marginTop: 12,
                        } }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u518D\u767A\u884C\u3059\u308B\u305F\u3081\u5BCC\u58EB\u5C71\u30DE\u30AC\u30B8\u30F3\u30B5\u30FC\u30D3\u30B9\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5B9B\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u767A\u884C\u306E\u6848\u5185\u30E1\u30FC\u30EB\u3092\u304A\u9001\u308A\u3057\u307E\u3059\u3002"),
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.loginForm },
                        react_1.default.createElement(InputField_1.default, { style: styles_1.default.input, placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B", placeholderTextColor: "#C8C8C8", label: "メールアドレス", onRightIconLabelPress: () => {
                                setVisibleEmail(!visibleEmail);
                            }, value: email, onChangeText: (text) => {
                                setEmail(text?.trim());
                                setErrorEmail("");
                            } }),
                        errEmail && (react_1.default.createElement(CustomText_1.default, { style: styles_1.default.err }, errEmail)),
                        react_1.default.createElement(components_1.SimpleButton, { onPress: () => {
                                validate();
                            }, title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u518D\u767A\u884C", style: { marginTop: (0, scale_1.scale)(32), width: (0, scale_1.scale)(343) } }))))),
        react_1.default.createElement(ModalExplain_1.default, { visible: visibleEmail, onClose: () => {
                setVisibleEmail(false);
            }, title: "Fujisan ID\u306B\u3064\u3044\u3066", content: "\u6295\u8CC7\u306E\u5148\u8F29\u3067\u306F\u3001\u682A\u5F0F\u4F1A\u793E\u5BCC\u58EB\u5C71\u30DE\u30AC\u30B8\u30F3\u30B5\u30FC\u30D3\u30B9\u304C\u63D0\u4F9B\u3057\u3066\u3044\u308B Fujisan ID \u3092\u30ED\u30B0\u30A4\u30F3\u306B\u4F7F\u7528\u3057\u3066\u3044\u307E\u3059\u3002" })));
};
exports.default = ForgotPassword;
